import { z } from 'zod';
import { ArtistIdSchema, IsoDateSchema } from './common.js';
import { CatalogueYearSchema, DEFAULT_SELECTORS } from './selectors.js';
export const MAX_PEERS = 12;
export const PeersQuerySchema = z.object({
    cat: CatalogueYearSchema.default(DEFAULT_SELECTORS.cat),
    /** Comma-separated artist ids. */
    peers: z
        .string()
        .optional()
        .transform((s) => s
        ? s
            .split(',')
            .map((x) => x.trim())
            .filter(Boolean)
        : [])
        .pipe(z.array(ArtistIdSchema).max(MAX_PEERS)),
    peerSetId: z.uuid().optional(),
    asOf: IsoDateSchema.optional(),
});
const RateSchema = z.object({
    ltm: z.number(),
    vsPrior: z.number().nullable(),
    cagr21: z.number().nullable(),
});
export const PeerRowSchema = z.object({
    artistId: ArtistIdSchema,
    artistName: z.string(),
    isSubject: z.boolean(),
    anchor: IsoDateSchema,
    /** True when this peer could not be computed at the subject's anchor. */
    anchorDiffers: z.boolean(),
    total: RateSchema,
    catalogue: RateSchema.extend({ share: z.number().nullable() }),
    cmRank: z.number().int().nullable(),
    hasOverrides: z.boolean(),
    trackCount: z.number().int(),
});
export const PeersResponseSchema = z.object({
    rows: z.array(PeerRowSchema),
    catalogueYear: z.number().int(),
    chartmetricAsOf: IsoDateSchema.nullable(),
});
//# sourceMappingURL=peers.js.map